import { Component } from '@angular/core'
import { environment } from 'src/environments/environment'
import { OnlineSubscriptionUrl } from '../../environments/defaultEnvironment'

@Component({
  selector: 'cover-digital-content-links',
  templateUrl: './digital-content-links.component.html',
  styleUrls: ['./digital-content-links.component.scss'],
})
export class DigitalContentLinksComponent {
  readonly digitalContentLinks = environment.onlineSubscriptionLink as unknown as OnlineSubscriptionUrl[]
  readonly customTitle: string | undefined = environment.onlineSubscriptionCustomTittle

  constructor() {}
}
